'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductSearchResultInfo } from '../../../product-search'

export const SearchPageResultHeader: FC = () => {
  return (
    <div className="flex flex-col">
      <h1 className="text-2xl font-medium tablet:text-4xl">
        <FormattedMessage id="general.label.SearchResult" />
      </h1>
      <ProductSearchResultInfo />
    </div>
  )
}
